import axios from "axios";
import { API_URL } from "../utils/constants";
import AuthenticationService from "./AuthenticationService";

const apiRequest = axios.create({
  baseURL: API_URL,
});

apiRequest.defaults.headers.common["Content-Type"] = "application/json";

export const requestInterceptor = (config) => {
  const { publicRequest, audit } = config;

  if (publicRequest && !audit) {
    return config;
  }

  const access_token = AuthenticationService.getUserData()?.access_token;

  const businessTokenExists = AuthenticationService.checkBusinessTokenExists();

  if (!businessTokenExists) {
    AuthenticationService.logout();
    AuthenticationService.sendToLogin();
  }

  if (!access_token && !audit) {
    AuthenticationService.logout();
    AuthenticationService.sendToLogin();
    throw new axios.Cancel("user not logged");
  }

  if (access_token) {
    config.headers["Authorization"] = `Bearer ${access_token}`;
  }

  return config;
};

export const responseInterceptor = (response) => {
  return response.data;
};

export const errorInterceptor = (error) => {
  if (error.response && error.response.status === 401) {
    AuthenticationService.logout();
    AuthenticationService.sendToLogin();
  }
  return Promise.reject(error);
};

apiRequest.interceptors.request.use(requestInterceptor, errorInterceptor);

apiRequest.interceptors.response.use(responseInterceptor, errorInterceptor);

export default apiRequest;
